import React from 'react';
import { string } from 'prop-types';
import * as styles from './styles/styles.module.scss';

const OnePercentModule = ({ title, iconSrc, text }) => {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        {/* alt text is empty see https://html.spec.whatwg.org/multipage/images.html#a-short-phrase-or-label-with-an-alternative-graphical-representation:-icons,-logos */}
        <img alt="" loading="lazy" src={iconSrc} />
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.text}>{text}</div>
    </div>
  );
};

OnePercentModule.propTypes = {
  title: string.isRequired,
  iconSrc: string.isRequired,
  text: string.isRequired
};

export default OnePercentModule;
